<nav class="navbar navbar-expand-md fixed-top navbar-light bg-dark" rt="app-header" [class.storefront-header]="storefrontEnabled">
  <!-- Storefront on: keep the desktop phone with the brand at every desktop breakpoint. -->
  <div *ngIf="storefrontEnabled; else desktopLogo" class="desktop-brand d-none d-lg-flex mr-3">
    <a class="navbar-brand" routerLink="/">
      <img [src]="navbarImage()" alt="Rubbl" />
    </a>
    <a href="tel:8664558531" class="desktop-brand-phone text-white text-nowrap" aria-label="Call Rubbl at (866) 455-8531">(866) 455-8531</a>
  </div>
  <ng-template #desktopLogo>
    <a class="navbar-brand d-none d-lg-block" routerLink="/">
      <img [src]="navbarImage()" alt="Rubbl" />
    </a>
  </ng-template>

  <!-- Mobile Logo (R icon) and Phone -->
  <div class="d-flex d-lg-none align-items-center">
    <a class="navbar-brand mobile-logo mr-2" routerLink="/">
      <img src="https://company.rubbl.com/pubweb/marketplace/images/logos/rubbl-logo-no-text.svg" alt="Rubbl" />
    </a>
    <a href="tel:(866) 455-8531" class="fs-17 mobile-phone text-white text-decoration-none">(866) 455-8531 </a>
  </div>

  <!-- Left side header items -->
  <div class="navbar-collapse left-nav-wrapper mr-4">
    <ul class="navbar-nav w-100">
      <ng-container *ngFor="let headerItem of leftSideHeaderItems">
        <li class="nav-item w-100">
          <ng-container *ngComponentOutlet="headerItem"></ng-container>
        </li>
      </ng-container>
    </ul>
  </div>

  <!-- Mobile header items -->
  <ul class="navbar-nav ml-auto d-lg-none mobile-nav">
    <ng-container *ngFor="let headerItem of mobileHeaderItems; let last = last">
      <li *ngIf="last" class="last-header-item-container"></li>
      <li class="nav-item" rt="header-mobile-component">
        <ng-container *ngComponentOutlet="headerItem"></ng-container>
      </li>
    </ng-container>
  </ul>

  <!-- Right side header items -->
  <div class="d-none d-lg-block">
    <ul class="navbar-nav ml-auto">
      <ng-container *ngFor="let headerItem of rightSideHeaderItems; let last = last">
        <li *ngIf="last" class="last-header-item-container test"></li>
        <li class="nav-item" rt="header-desktop-component">
          <ng-container *ngComponentOutlet="headerItem"></ng-container>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
